export const VERSION_UPDATE = "VERSION_UPDATE";
export const VERSION_TEST = "VERSION_TEST";

// Routes
export const GET_ROUTES = "GET_ROUTES";
export const GET_ROUTE = "GET_ROUTE";
export const SYNC_ROUTES = "SYNC_ROUTES";

// Users
export const GET_USERS = "GET_USERS";
export const GET_USER = "GET_USER";
export const ASSIGN_USER_TO_ROUTES = "ASSIGN_USER_TO_ROUTES";
export const REMOVE_USERS_FROM_ROUTES = "REMOVE_USERS_FROM_ROUTES";
export const REMOVE_USER_FROM_ROUTES = "REMOVE_USER_FROM_ROUTES";
export const GET_USERS_FOR_ROUTE = "GET_USERS_FOR_ROUTE";
export const ASSIGN_USERS_TO_ROUTE = "ASSIGN_USERS_TO_ROUTE";
export const SYNC_USERS = "SYNC_USERS";
export const CLEAR_USERS = "CLEAR_USERS";
export const GET_USERS_BY_ID = "GET_USERS_BY_ID";

// Tags
export const ADD_CATEGORY = "ADD_CATEGORY";
export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_CATEGORY = "GET_CATEGORY";
export const GET_CATEGORIES_WITH_IDS = "GET_CATEGORIES_WITH_IDS";
export const UPDATE_CATEGORY_NAME = "UPDATE_CATEGORY_NAME";
export const REMOVE_CATEGORIES = "REMOVE_CATEGORIES";
export const ADD_PRODUCTS_TO_CATEGORIES = "ADD_PRODUCTS_TO_CATEGORIES";
export const REMOVE_PRODUCTS_FROM_CATEGORIES = "REMOVE_PRODUCTS_FROM_CATEGORIES";
export const GET_CATEGORIES_FOR_PRODUCT = "GET_CATEGORIES_FOR_PRODUCT";
export const ADD_CATEGORIES_TO_GROUP = "ADD_CATEGORIES_TO_GROUP";
export const GET_PRODUCT_GROUPS_FOR_CATEGORY = "GET_PRODUCT_GROUPS_FOR_CATEGORY";

// Products
export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_PRODUCTS_WITH_IDS = "GET_PRODUCTS_WITH_IDS";
export const GET_PRODUCT = "GET_PRODUCT";
export const GET_MASTER_TAGS = "GET_MASTER_TAGS";
export const GET_PRODUCT_GROUPS_FOR_PRODUCT = "GET_PRODUCT_GROUPS_FOR_PRODUCT";
export const PROVIDE_PRODUCT_GROUPS_FOR_PRODUCT = "PROVIDE_PRODUCT_GROUPS_FOR_PRODUCT";

// Groups
export const ADD_GROUP = "ADD_GROUP";
export const GET_GROUP = "GET_GROUP";
export const GET_GROUPS_WITH_IDS = "GET_GROUPS_WITH_IDS";
export const UPDATE_GROUP = "UPDATE_GROUP";
export const GET_GROUPS = "GET_GROUPS";
export const REMOVE_GROUPS = "REMOVE_GROUPS";
export const ADD_DATA_COLLECTION_TO_GROUP = "ADD_DATA_COLLECTION_TO_GROUP";
export const REMOVE_DATA_COLLECTION_FROM_GROUP = "REMOVE_DATA_COLLECTION_FROM_GROUP";

// Must Sell SKUs
export const CREATE_MUST_SELL_SKU = "CREATE_MUST_SELL_SKU";
export const DELETE_MUST_SELL_SKUS = "DELETE_MUST_SELL_SKUS";
export const GET_MUST_SELL_SKUS = "GET_MUST_SELL_SKUS";
export const GET_MUST_SELL_SKU = "GET_MUST_SELL_SKU";
export const GET_MUST_SELL_SKU_PRODUCT_GROUPS = "GET_MUST_SELL_SKU_PRODUCT_GROUPS";
export const UPDATE_MUST_SELL_SKU = "UPDATE_MUST_SELL_SKU";
export const GET_MUST_SELL_SKUS_BY_IDS = "GET_MUST_SELL_SKUS_BY_IDS";

//Targeting
export const GET_ALL_TARGETED_CONTENT = "GET_ALL_TARGETED_CONTENT";
export const GET_TARGET_GROUPS = "GET_TARGET_GROUPS";
export const GET_ACTIVE_TARGETED_CONTENT = "GET_ACTIVE_TARGETED_CONTENT";
export const GET_TARGET_GROUP = "GET_TARGET_GROUP";
export const GET_TARGET_GROUPS_BY_IDS = "GET_TARGET_GROUPS_BY_IDS";

export const CREATE_TARGETED_CONTENT = "CREATE_TARGETED_CONTENT";
export const CREATE_TARGET_GROUPS = "CREATE_TARGET_GROUPS";
export const END_TARGETED_CONTENT_EARLY = "END_TARGETED_CONTENT_EARLY";
export const PREVIEW_TARGET_GROUP = "PREVIEW_TARGET_GROUP";
export const DELETE_TARGET_GROUP = "DELETE_TARGET_GROUP";

export const UPDATE_CURRENT_CAMPAIGN = "UPDATE_CURRENT_CAMPAIGN";
export const RESET_CURRENT_CAMPAIGN = "RESET_CURRENT_CAMPAIGN";

export const UPDATE_CURRENT_TARGET_GROUP = "UPDATE_CURRENT_TARGET_GROUP";
export const RESET_CURRENT_TARGET_GROUP = "RESET_CURRENT_TARGET_GROUP";

//File Download
export const GET_ALL_FILES = "GET_ALL_FILES";
export const DOWNLOAD_FILE = "DOWNLOAD_FILE";
export const UPLOAD_FILE = "UPLOAD_FILE";
export const GET_FILES_BY_IDS = "GET_FILES_BY_IDS";
export const DELETE_FILES_BY_IDS = "DELETE_FILES_BY_IDS";
export const GET_CURRENT_CONTENT = "GET_CURRENT_CONTENT";

//Forms
export const GET_FORMS = "GET_FORMS";
export const GET_FORMS_BY_IDS = "GET_FORMS_BY_IDS";
export const GET_FORM_JSON = "GET_FORM_JSON";
export const CLEAR_FORM = "CLEAR_FORM";
export const DELETE_FORMS = "DELETE_FORMS";
export const UPDATE_FORM = "UPDATE_FORM";
export const UPDATE_CURRENT_FORM = "UPDATE_CURRENT_FORM";
export const SET_CURRENT_FORM_TITLE = "SET_CURRENT_FORM_TITLE";

//Objectives
export const GET_OBJECTIVES = "GET_OBJECTIVES";
export const GET_RELATED_OBJECTIVES = "GET_RELATED_OBJECTIVES";
export const GET_OBJECTIVE = "GET_OBJECTIVE";
export const UPDATE_OBJECTIVES = "UPDATE_OBJECTIVES";
export const DELETE_OBJECTIVES = "DELETE_OBJECTIVES";

//Call Schedule
export const GET_CALL_SCHEDULE_TYPE_IDS = "GET_CALL_SCHEDULE_TYPE_IDS";
export const GET_CALL_SCHEDULE_TYPE_FILTER = "GET_CALL_SCHEDULE_TYPE_FILTER";
export const UPDATE_CALL_SCHEDULE_TYPE_FILTER = "UPDATE_CALL_SCHEDULE_TYPE_FILTER";

//Order History
export const GET_ORDERS_BY_FILTER = "GET_ORDERS_BY_FILTER";
export const GET_ORDER = "GET_ORDER";
export const CLEAR_ORDERS = "CLEAR_ORDERS";
export const GET_RELATED_ORDERS = "GET_RELATED_ORDERS";

//ImageManagement
export const GET_RESOURCE_IMAGES = "GET_RESOURCE_IMAGES";
export const UPLOAD_RESOURCE_IMAGES = "UPLOAD_RESOURCE_IMAGES";
export const DOWNLOAD_RESOURCE_IMAGE = "DOWNLOAD_RESOURCE_IMAGE";
export const CLEAR_RESOURCE_IMAGES = "CLEAR_RESOURCE_IMAGES";
export const DELETE_RESOURCE_IMAGES = "DELETE_RESOURCE_IMAGES";

//Out Of Stock
export const GET_OUT_OF_STOCK_LIST = "GET_OUT_OF_STOCK_LIST";
export const UPDATE_OUT_OF_STOCK_LIST = "UPDATE_OUT_OF_STOCK_LIST";

//Distributors
export const GET_DISTRIBUTORS_FOR_USER = "GET_DISTRIBUTORS_FOR_USER";
export const GET_DISTRIBUTORS = "GET_DISTRIBUTORS";
export const UPDATE_USER_DISTRIBUTORS = "UPDATE_USER_DISTRIBUTORS";
export const GET_ADMINISTRATORS = "GET_ADMINISTRATORS";
export const UPDATE_ADMINISTRATORS = "UPDATE_ADMINISTRATORS";

//Hierarchies
export const GET_HIERARCHY = "GET_HIERARCHY";
export const CREATE_NODE = "CREATE_NODE";
export const DELETE_NODE = "DELETE_NODE";
export const ADD_RELATIONSHIP = "ADD_RELATIONSHIP";
export const DELETE_RELATIONSHIP = "DELETE_RELATIONSHIP";
export const ADD_LEAF_NODES = "ADD_LEAF_NODES";
export const GET_BARCODES_FOR_NODE = "GET_BARCODES_FOR_NODE";
export const UPDATE_BARCODES_FOR_NODE = "UPDATE_BARCODES_FOR_NODE";
export const GET_NODE = "GET_NODE";
export const GET_USERS_FOR_NODE = "GET_USERS_FOR_NODE";
export const UPDATE_USERS_FOR_NODE = "UPDATE_USERS_FOR_NODE";
export const GET_SELLING_DAYS_FOR_NODE = "GET_SELLING_DAYS_FOR_NODE";
export const UPDATE_SELLING_DAYS_FOR_NODE = "UPDATE_SELLING_DAYS_FOR_NODE";
export const CLEAR_SELLING_DAYS_FOR_NODE = "CLEAR_SELLING_DAYS_FOR_NODE";
export const GET_OBJECTIVES_FOR_NODE = "GET_OBJECTIVES_FOR_NODE";
export const SET_OBJECTIVES_FOR_NODE = "SET_OBJECTIVES_FOR_NODE";
export const CLEAR_OBJECTIVES_FOR_NODE = "CLEAR_OBJECTIVES_FOR_NODE";
export const SET_HEIRARCHY_EXPANSION = "SET_HEIRARCHY_EXPANSION";

//FeatureFlags
export const GET_FEATURE_FLAGS = "GET_FEATURE_FLAGS";
export const UPDATE_FEATURE_FLAGS = "UPDATE_FEATURE_FLAGS";

//CustomerFlag
export const GET_CUSTOMER_FLAGS = "GET_CUSTOMER_FLAGS";
export const GET_CUSTOMER_FLAG = "GET_CUSTOMER_FLAG";
export const UPDATE_CUSTOMER_FLAGS = "UPDATE_CUSTOMER_FLAGS";
export const GET_CUSTOMER_FLAGS_BY_IDS = "GET_CUSTOMER_FLAGS_BY_IDS";
export const DELETE_CUSTOMER_FLAGS = "DELETE_CUSTOMER_FLAGS";

//Price Lists
export const GET_PRICE_LISTS = "GET_PRICE_LISTS";
export const GET_PRICE_LIST = "GET_PRICE_LIST";
export const SAVE_PRICE_LIST = "SAVE_PRICE_LIST"
export const DELETE_PRICE_LIST = "DELETE_PRICE_LIST"

//User Roles
export const GET_USER_ROLES = "GET_USER_ROLES";
export const UPSERT_USER_ROLE = "UPSERT_USER_ROLE";
export const GET_USER_ROLE = "GET_USER_ROLE";
export const DELETE_USER_ROLE = "DELETE_USER_ROLE";
export const GET_USERS_FOR_ROLE = "GET_USERS_FOR_ROLE";
export const SET_USERS_FOR_ROLE = "SET_USERS_FOR_ROLE";
export const GET_ROLES_FOR_USER = "GET_ROLES_FOR_USER";
export const SET_ROLES_FOR_USER = "SET_ROLES_FOR_USER";

//Coded Values
export const GET_CODED_VALUES = "GET_CODED_VALUES";
export const GET_CODED_VALUE = "GET_CODED_VALUE";
export const GET_CODED_TYPES = "GET_CODED_TYPES";
export const CREATE_CODED_VALUE = "CREATE_CODED_VALUE";
export const UPDATE_CODED_VALUE = "UPDATE_CODED_VALUE";
export const DELETE_CODED_VALUES = "DELETE_CODED_VALUES";
export const DELETE_CODED_VALUE = "DELETE_CODED_VALUE";
export const CLEAR_CODED_VALUES_TOKEN = "CLEAR_CODED_VALUES_TOKEN";

//Dashboard Layouts
export const GET_DASHBOARD_LAYOUTS = "GET_DASHBOARD_LAYOUTS";
export const GET_DASHBOARD_LAYOUTS_BY_IDS = "GET_DASHBOARD_LAYOUTS_BY_IDS";
export const SET_DASHBOARD_LAYOUT = "SET_DASHBOARD_LAYOUT";
export const DELETE_DASHBOARD_LAYOUT = "SET_DASHBOARD_LAYOUT";
export const GET_CURRENT_DASHBOARD_LAYOUT = "GET_CURRENT_DASHBOARD_LAYOUT";
export const CLEAR_CURRENT_DASHBOARD_LAYOUT = "CLEAR_CURRENT_DASHBOARD_LAYOUT";
